import {
  readStorageBoolean,
  readStorageEnum,
  readStorageJson,
  readStorageString,
  setStorageBoolean,
  setStorageEnum,
  setStorageJson,
  setStorageString,
} from './helpers'

export type Storage<R, W> = {
  read: () => R
  set: (value?: W) => void
}

export function getStringStorageReader(key: string) {
  return {
    read: () => readStorageString(key),
    set: (value?: string) => setStorageString(key, value),
  } satisfies Storage<any, any>
}

export function getBooleanStorageReader(key: string, defaultValue: boolean) {
  return {
    read: () => readStorageBoolean(key, defaultValue),
    set: (value?: boolean) => setStorageBoolean(key, value),
  } satisfies Storage<any, any>
}

export function getEnumStorageReader<O extends string, D extends O | undefined>(
  key: string,
  options: readonly O[],
  defaultValue: D
) {
  return {
    read: () => readStorageEnum(key, options, defaultValue),
    set: (value?: O | D) => setStorageEnum(key, value),
  } satisfies Storage<any, any>
}

export function getJsonStorageReader(key: string) {
  return {
    read: () => readStorageJson(key),
    set: (value?: any) => setStorageJson(key, value),
  } satisfies Storage<any, any>
}
